<template>
	<div>
		<el-row :gutter="20" style="margin-top:10px;">
			<el-col :xs="24" :sm="24" :md="10" :lg="8" :xl="8">
				<div class="grid-content bg-purple">
					<el-card class="box-card">
						<div slot="header" class="clearfix">
							<span>个人中心</span>
						</div>
						<div class="name-role">
							<span class="sender">欢迎 - {{userInfo.username}}</span>
						</div>
						<div class="registe-info">
							<span class="registe-info">
								账户ID：：
								<!-- <li class="el-icon-alarm-clock"></li> -->
								{{userInfo.UID}}
							</span>
						</div>
						<el-divider></el-divider>
						<div class="personal-relation">
							<div class="relation-item">邮箱: <div style="float: right; padding-right:20px;">

									<span v-if="userInfo.email===null">未绑定</span>
									<span v-else>{{userInfo.email}}</span>
								</div>
							</div>
						</div>
						<div class="personal-relation">
							<div class="relation-item">离线提醒: <div style="float: right; padding-right:20px;">
							<el-switch v-model="isoffline" @change="openorcloseoffline()" :active-value="true"
								:inactive-value="false" inactive-color="#ff0000" active-color="#4de700">
							</el-switch>
							</div>
							</div>
						</div>
						<div class="personal-relation">
							<div class="relation-item">用户状态: <div style="float: right; padding-right:20px;">
									<span v-if="userInfo.status===-2">
										<el-tag type="danger">未绑定谷歌验证</el-tag>
									</span>
									<span v-else-if="userInfo.status===-1">
										<el-tag type="danger">账户被封禁</el-tag>
									</span>
									<span v-else-if="userInfo.status===0">
										<el-tag type="success">状态正常</el-tag>
									</span>
									<span v-else-if="userInfo.status===9">
										<el-tag type="warning">优惠账户</el-tag>
									</span>
									<span v-else-if="userInfo.status===77">
										<el-tag type="warning">VIP1</el-tag>
									</span>
									<span v-else-if="userInfo.status===88">
										<el-tag type="warning">VIP2</el-tag>
									</span>
									<span v-else-if="userInfo.status===99">
										<el-tag type="warning">VIP3</el-tag>
									</span>
									<span v-else>
										<el-tag type="danger">未知</el-tag>
									</span>
								</div>
							</div>
						</div>
						
						
<!-- 						<div class="personal-relation">
							<div class="relation-item">用户等级: <div style="float: right; padding-right:20px;">
									<span v-if="userInfo.level===0">
										<img src="../../img/level-1.png" style="margin-top: 5px;" height="36"/>
									</span>
									<span v-else-if="userInfo.level===1">
										<img src="../../img/level-2.png" style="margin-top: 5px;" height="36"/>
									</span>
									<span v-else-if="userInfo.level===2">
										<img src="../../img/level-3.png" style="margin-top: 5px;" height="36"/>
									</span>
									<span v-else-if="userInfo.level===3">
										<img src="../../img/level-4.png" style="margin-top: 5px;" height="36"/>
									</span>
									<span v-else-if="userInfo.level===4">
										<img src="../../img/level-5.png" style="margin-top: 5px;" height="36"/>
									</span>
									<span v-else-if="userInfo.level===5">
										<img src="../../img/level-6.png" height="36"/>
									</span>
									
									<span v-else>
										<img src="../../img/level-1.png" style="margin-top: 5px;" height="36"/>
									</span>
								</div>
							</div>
						</div> -->
						
<!-- 						<div class="personal-relation">
							<div class="relation-item">上级用户: <div style="float: right; padding-right:20px;">
									<span v-if="userInfo.inviterid===0">
										无上级
									</span>
									<span v-else>
										ID:{{userInfo.inviterid}}
									</span>
								</div>
							</div>
						</div> -->
						
					</el-card>
				</div>
			</el-col>
			<el-col :xs="24" :sm="24" :md="14" :lg="16" :xl="16">
				<div class="grid-content bg-purple">
					<el-card class="box-card">
						<div slot="header" class="clearfix">
							<span>信息修改</span>
						</div>
						<el-tabs v-model="activeName">
							<el-tab-pane label="绑定邮箱" name="first">
								<div>
									<el-form label-width="100px" v-model="emailForm" ref="emailForm" size="small" label-position="right" :rules="rules">
										<el-form-item prop="email" label="邮箱" >
											<el-input auto-complete="off" v-model="emailForm.email"></el-input>
										</el-form-item>
										<el-form-item prop="emailcode" label="邮箱验证码" >
											<el-input maxlength="8" v-model="emailForm.emailcode">
												<el-button style="padding-right:10px" slot="suffix" type="text"
													@click="sendcode" v-bind:disable="dis">
													{{sendcodebtn}}
												</el-button>
											</el-input>
										</el-form-item>
										<el-form-item prop="googlecode" label="谷歌验证码" >
											<el-input maxlength="6" v-model="emailForm.googlecode"></el-input>
										</el-form-item>
									</el-form>
									<div slot="footer" class="dialog-footer">
										<el-button size="mini" type="primary" @click="bindemail">提交</el-button>

									</div>
								</div>
							</el-tab-pane>
							<el-tab-pane label="修改密码" name="second">
								<div>
									<el-form label-width="90px" v-model="pwdForm" size="small" label-position="right">
										<el-form-item label="当前密码">
											<el-input auto-complete="off" show-password v-model="pwdForm.pwd"></el-input>
										</el-form-item>
										<el-form-item label="新密码">
											<el-input maxlength="18" show-password v-model="pwdForm.npwd"></el-input>
										</el-form-item>
										<el-form-item label="确认密码">
											<el-input maxlength="18" show-password v-model="pwdForm.cpwd"></el-input>
										</el-form-item>
										<el-form-item label="谷歌验证码">
											<el-input maxlength="6" v-model="pwdForm.googlecode"></el-input>
										</el-form-item>
									</el-form>
									<div slot="footer" class="dialog-footer">
										<el-button size="mini" type="primary" @click="changepwd">提交</el-button>

									</div>
								</div>
							</el-tab-pane>

						</el-tabs>

					</el-card>
				</div>
			</el-col>

		</el-row>
	</div>
</template>

<script>
	var axios = require('axios');
	var qs = require('qs');

	export default {
		data() {
			var checkEmail = (rule, value, callback) => {
				value=this.emailForm.email
				const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
				
				if (!value) {
					return callback(new Error('邮箱不能为空'))
				}
				setTimeout(() => {
					if (mailReg.test(value)) {
						callback()
					} else {
						callback(new Error('请输入正确的邮箱格式'))
					}
				}, 100)
			}
			return {
				rules:{
					email: [
					      { validator: checkEmail, trigger: 'blur' }
					    ]
				},
				url: this.$global.url,//"https://api.starmap.stream",//https://api.starmap.stream
				token: "",
				dataForm: {
					username: '',
					email: '',
				},
				userInfo: {
					username: "",
					UID: "",
					email: "",
					status: -2,
					level:0,
					inviterid:0

				},
				emailForm: {
					email: "",
					emailcode: "",
					googlecode: ""
				},
				pwdForm: {
					pwd: "",
					npwd: "",
					cpwd: "",
					googlecode: ""
				},
				sendcodebtn: "点我获取",
				activeName: "first",
				dis: false,
				isoffline:true,
				

			}
		},
		mounted() {
			this.initUserInfo()
			this.getofflinestatus()
			this.emailForm.email = this.userInfo.email
		},
		created() {
			this.token = localStorage.getItem("token")

		},
		methods: {
			getofflinestatus(){
				let that=this
				var config = {
				  method: 'get',
				  url: this.url+'/api/user/offlinestatus',
				  headers: { 
				    'token': this.token
				  }
				};
				
				axios(config)
				.then(function (response) {
					that.isoffline=response.data.data
				  // console.log(JSON.stringify(response.data));
				})
				.catch(function (error) {
				  console.log(error);
				});

			},
			openorcloseoffline(){
				if (this.isoffline === true) {
					this.openoffline()
				} else {
					this.closeoffline()
				}
			},
			openoffline(){
				let that=this
				var config = {
				  method: 'get',
				  url: this.url+'/api/user/openofflinewarn',
				  headers: { 
				    'token':this.token
				  }
				};
				
				axios(config)
				.then(function (response) {
					if(response.data.data===true){
						that.$message.success("开启成功")
					}else{
						that.$message.error("开启失败")
					}
				})
				.catch(function (error) {
				  console.log(error);
				});
			},
			closeoffline(){
				let that=this
				var config = {
				  method: 'get',
				  url: this.url+'/api/user/closeofflinewarn',
				  headers: { 
				    'token':this.token
				  }
				};
				
				axios(config)
				.then(function (response) {
					if(response.data.data===true){
						that.$message.success("关闭成功")
					}else{
						that.$message.error("关闭失败")
					}
				})
				.catch(function (error) {
				  console.log(error);
				});

			},
			initUserInfo() {
				let that = this
				var data = qs.stringify({

				});
				var config = {
					method: 'post',
					url: this.url + '/api/getUserInfo',
					headers: {
						'token': this.token
					},
					data: data
				};

				axios(config)
					.then(function(response) {
						// console.log("token:" + that.token)
						if (response.data.code === 0) {
							that.userInfo = response.data.data
							
							// console.log(that.userInfo)
						} else if (response.data.code === 4002) {
							that.$message.error("登陆状态失效，请重新登陆")
							that.$router.push("/login?redirect=/labs/user")

						}

						// console.log(JSON.stringify(response.data));
					})
					.catch(function(error) {
						console.log(error);
					});
			},

			bindemail() {
				let that = this
				var data = qs.stringify(this.emailForm);
				var config = {
					method: 'post',
					url: this.url + '/api/bindEmail',
					headers: {
						'token': this.token,
						'Content-Type': 'application/x-www-form-urlencoded'
					},
					data: data
				};

				axios(config)
					.then(function(response) {
						if (response.data.code === 0) {
							that.$message.success("绑定邮箱成功")
							that.initUserInfo()
						} else if (response.data.code === 14011) {
							that.$message.error("谷歌验证失败")
						} else if (response.data.code === 14012) {
							that.$message.error("邮箱验证失败")
						}
						// console.log(JSON.stringify(response.data));
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			changepwd() {
				if(this.pwdForm.cpwd!=this.pwdForm.npwd){
					this.$message.error("输入两次密码不正确")
					return
				}
				var data = qs.stringify({
				  'pwd': this.pwdForm.pwd,
				  'npwd': this.pwdForm.npwd,
				  'googlecode':this.pwdForm.googlecode 
				});
				var config = {
				  method: 'post',
				  url: this.url+'/api/changepwd',
				  headers: { 
				    'token': this.token, 
				    'Content-Type': 'application/x-www-form-urlencoded'
				  },
				  data : data
				};
				let that=this
				axios(config)
				.then(function (response) {
					if(response.data.code===0){
						that.$message.success("更新成功，请重新登录")
	
						that.$router.push({
							path: "/login?redirect=/labs/eth-index"
						});
					}else if(response.data.code===4005){
						that.$message.error("原密码错误")
					}else if(response.data.code===14011){
						that.$message.error("谷歌验证码错误")
					}else{
						that.$message.error("未知错误")
					}
				  // console.log(JSON.stringify(response.data));
				})
				.catch(function (error) {
				  console.log(error);
				});

				

			},
			sendcode() {
				let that = this
				var data = qs.stringify({
					'email': this.emailForm.email
				});
				var config = {
					method: 'post',
					url: this.url + '/api/sendEmailCode',
					headers: {
						'token': this.token,
						'Content-Type': 'application/x-www-form-urlencoded'
					},
					data: data
				};

				axios(config)
					.then(function(response) {
						if (response.data.code === 0) {
							that.$message.success("发送成功")
							that.dis = true

							setTimeout(that.dis = false, 5000);
						} else {
							that.$message.error("发送失败")
						}
						// console.log(JSON.stringify(response.data));
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			setbtn() {



			}



		}
	}
</script>

<style lang="scss" scoped>
	//卡片样式
	.text {
		font-size: 14px;
	}

	.item {
		margin-bottom: 18px;
	}

	.clearfix:before,
	.clearfix:after {
		display: table;
		content: "";
	}

	.clearfix:after {
		clear: both
	}

	.box-card {
		width: 100%;
	}

	//文本样式区
	.name-role {
		font-size: 16px;
		padding: 5px;
		text-align: center;
	}

	.sender {
		text-align: center;
	}

	.registe-info {
		text-align: center;
		padding-top: 10px;
	}

	.personal-relation {
		font-size: 16px;
		padding: 0px 5px 15px;
		margin-right: 1px;
		width: 100%
	}

	.relation-item {
		padding: 12px;

	}

	.dialog-footer {
		padding-top: 10px;
		padding-left: 10%;
	}

	//布局样式区
	.el-row {
		margin-bottom: 20px;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.el-col {
		border-radius: 4px;
	}

	.bg-purple-dark {
		background: #99a9bf;
	}

	.bg-purple {
		background: #d3dce6;
	}

	.bg-purple-light {
		background: #e5e9f2;
	}

	.grid-content {
		border-radius: 4px;
		min-height: 36px;
	}

	.row-bg {
		padding: 10px 0;
		background-color: #f9fafc;
	}
</style>
